<template>
  <widget>
    <widget-header @close="$emit('close')">
      Edit Contact
    </widget-header>
    <widget-body>
      <form @submit.prevent="update" ref="form" class="x-form">
        <YInput v-model="contact.name" label="User Name"></YInput>
        <YInput v-model="contact.email" label="Email"></YInput>
      </form>
    </widget-body>
    <widget-footer class="bg-gray-100 py-2 px-4 text-right">
      <y-button
        class="btn btn-blue"
        :is-loading="isSubmitting"
        @click="updateAdvertiserContact"
        @keydown.enter="updateAdvertiserContact"
        >Save Changes</y-button
      >
    </widget-footer>
    <ValidationErrors
      v-if="validationErrors"
      :errors="validationErrors"
    ></ValidationErrors>
  </widget>
</template>

<script>
import ValidationErrorsMixin from '@/mixins/ValidationErrorsMixin'
import UPDATE_CONTACT_MUTATION from '@/graphql/Contact/UpdateContactMutation.gql'

export default {
  mixins: [ValidationErrorsMixin],
  props: {
    id: {
      type: Number,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    email: {
      type: String,
      required: true
    }
  },
  components: {},
  apollo: {},
  data() {
    return {
      contact: {
        id: this.id,
        name: this.name,
        email: this.email
      },
      isSubmitting: false,
      colSize: 'col-xl-3 col-lg-6',
      colSize2: 'col-xl-6 col-lg-12',
      yLeadtypeOptions: ['lead', 'real', 'none']
    }
  },
  watch: {},
  computed: {},
  methods: {
    updateAdvertiserContact() {
      this.isSubmitting = true
      let input = {
        id: this.id,
        name: this.contact.name,
        email: this.contact.email
      }

      this.$apollo
        .mutate({
          mutation: UPDATE_CONTACT_MUTATION,
          variables: {
            input: input
          }
        })
        .then(result => {
          this.clearValidationErrors()
          this.$toastr.s('', 'Advertiser Contact Updated!')
          console.log(result)
          this.isSubmitting = false
          this.$events.emit('refreshAdvertiserContacts', true)
          this.$emit('close')
        })
        .catch(error => {
          this.setValidationErrors(error)
          this.isSubmitting = false
        })
    }
  },

  mounted() {},
  updated() {}
}
</script>
<style scoped>
.x-form > *:not(:last-child) {
  @apply mb-2;
}
</style>
